import { render, staticRenderFns } from "./GlobalVariableAdd.vue?vue&type=template&id=1411e72a"
import script from "./GlobalVariableAdd.vue?vue&type=script&lang=js"
export * from "./GlobalVariableAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports